import { ENV } from '@/env/public';

import { isBrowser } from '@/lib/browser';

const config = isBrowser ? window.PUBLIC_ENV : ENV;

export default config;
